<div class="annex-group-view-container" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" *ngIf="!annex.overvoltage">
    <button
      (click)="modify()"
      [disabled]="!(userPermissions | async).settlement.write"
      mat-stroked-button color="primary"
    ><mat-icon>create</mat-icon> <span> Edytuj</span></button>
  </div>

  <div fxLayout="column" fxLayoutGap="15px" fxFlex="100" *ngFor="let group of annex.groups">
    <mat-card class="mat-elevation-z4" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
      <div fxLayout="row" fxLayoutGap="15px">
        <app-detail fxFlex="33" header="Stawka % Partner">
          <mat-chip-list>
            <mat-chip *ngIf="group.ratePaid !== null" color="accent" selected>{{group.ratePaid}}</mat-chip>
          </mat-chip-list>
        </app-detail>

        <app-detail fxFlex="33" header="Stawki % TU">
          <mat-chip-list>
            <ng-container *ngFor="let rate of group.ratesArray;">
              <mat-chip color="accent" selected>{{rate}}</mat-chip>
            </ng-container>
          </mat-chip-list>
        </app-detail>
      </div>

      <mat-card class="mat-elevation-z2" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
        <h3>Progi</h3>

        <ng-container *ngFor="let threshold of group.thresholds; index as i">
          <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around end">
            <div fxFlex="55px" class="list-counter-thresholds">
              <span>{{i+1}}.</span>
            </div>

            <app-detail fxFlex header="Typ" [value]="threshold.type?.name"></app-detail>

            <app-detail fxFlex header="Próg" [value]="threshold.thresholdDictionary?.name"></app-detail>

            <app-detail fxFlex header="Suma od" [value]="threshold.thresholdFrom?.toString()"></app-detail>

            <app-detail fxFlex header="Suma do" [value]="threshold.thresholdTo?.toString()"></app-detail>
          </div>
        </ng-container>
      </mat-card>

      <mat-card class="mat-elevation-z2" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
        <h3>Ryzyka</h3>

        <ng-container *ngFor="let risk of group.risks; index as i">
          <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around end">
            <div fxFlex="55px" class="list-counter">
              <span>{{i+1}}.</span>
            </div>

            <div fxFlex fxLayout="column" fxLayoutGap="15px">
              <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around end">
                <app-detail fxFlex header="Słownik ryzyk" [value]="risk.riskDictionary?.name"></app-detail>

                <app-detail fxFlex header="Kod grupy" [value]="risk.groupName"></app-detail>

                <app-detail fxFlex header="Kod ryzyka" [value]="risk.name"></app-detail>
              </div>

              <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around end">
                <app-detail fxFlex header="Riders" [value]="risk.riders"></app-detail>

                <app-detail fxFlex header="Stawki % TU">
                  <mat-chip-list>
                    <ng-container *ngFor="let rate of risk.ratesArray;">
                      <mat-chip color="accent" selected>{{rate}}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>

                <app-detail fxFlex header="Stawka % Partner">
                  <mat-chip-list>
                    <mat-chip *ngIf="risk.ratePaid !== null" color="accent" selected>{{risk.ratePaid}}</mat-chip>
                  </mat-chip-list>
                </app-detail>
              </div>
            </div>

          </div>
        </ng-container>
      </mat-card>

    </mat-card>
  </div>

</div>
